import spotify from '../../img/streaming-platform-images/spotify.svg';
import JioSaavn from '../../img/streaming-platform-images/jio-saavn.svg';
import Wynk from '../../img/streaming-platform-images/wynk.svg';
import AmzazonMusic from '../../img/streaming-platform-images/amazon-music.svg';
import Gaana from '../../img/streaming-platform-images/gaana.svg';
import AppleMusic from '../../img/streaming-platform-images/apple-music.svg';
import Hungama from '../../img/streaming-platform-images/hungama.svg';
import YtMusic from '../../img/streaming-platform-images/yt-music.svg';
import Instagrammakereels from '../../img/streaming-platform-images/instagram_1.svg';
import YouTube from '../../img/streaming-platform-images/youtube.png';
import Deezer from '../../img/streaming-platform-images/Deezer.svg';
import imgThumbnail from '../../img/thumbnail.png';
import website from '../../img/socialHandles/website.png'
import FacebookImg from "../../img/socialHandles/facebook2.png";
import Twitter from '../../img/socialHandles/x.png'

export const getStrPlatformImg = (platform_key) => {
    switch (platform_key) {
        case 'jiosaavn':
            return JioSaavn;
        case 'wynk':
            return Wynk;
        case 'spotify':
            return spotify;
        case 'hungama':
            return Hungama;
        case 'gaana':
            return Gaana;
        case 'amazonmusic':
        case 'amazon music':
            return AmzazonMusic;
        case 'applemusic':
            return AppleMusic;
        case 'youtube':
            case 'Youtube':
            return YouTube;
        case 'youtubemusic':
        case 'youtube music':
            return YtMusic;
        case 'Instagrammakereels':
            case 'Instagram':
            case 'instagram':
            return Instagrammakereels;
        case 'deezer':
            return Deezer;
        case 'website':
            return website;
        case 'facebook':
            return FacebookImg;
        case 'twitter':
            return Twitter;

        default:
            return imgThumbnail;
    }
};
